import { render, staticRenderFns } from "./SBPMiscPaymentDialog.vue?vue&type=template&id=4cbe8e48&"
import script from "./SBPMiscPaymentDialog.vue?vue&type=script&lang=js&"
export * from "./SBPMiscPaymentDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports